/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Documents_DescriptionInputs */

const en_orders_documents_description = /** @type {(inputs: Orders_Documents_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View BOL and delivery order documents without leaving logistics.`)
};

const es_orders_documents_description = /** @type {(inputs: Orders_Documents_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver BOL y resumen del pedido sin salir de logistica.`)
};

/**
* | output |
* | --- |
* | "View BOL and delivery order documents without leaving logistics." |
*
* @param {Orders_Documents_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_documents_description = /** @type {((inputs?: Orders_Documents_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Documents_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_documents_description(inputs)
	return es_orders_documents_description(inputs)
});